<template>
    <MainLayout>
        <LoaderPage v-if="loadingPage" />
        <EstacaoComponent :theme="theme" />
        <HeaderSilo :theme="theme" :silo="silo" :unidadeId="unidadeId"/>
        <main :class="theme === 'dark' ? 'tw-bg-[#151515]' : 'tw-bg-white'" class="tw-mx-auto tw-p-6">
            <div class="tw-grid tw-grid-cols-1 tw-gap-6">
                <section :class="theme === 'dark' ? 'tw-bg-[#151515]' : 'tw-bg-white'" class="tw-rounded-2xl md:tw-p-6 tw-p-y-6">
                    <div class="tw-mb-6">
                        <div class="tw-flex tw-gap-8">
                            <button
                                @click="activateTabPrincipal(true)"
                                :class="[
                                    'tw-pb-4 tw-font-semibold tw-text-sm',
                                    tabPrincipal
                                        ? theme === 'dark' 
                                            ? 'tw-text-emerald-400 tw-border-b-2 tw-border-emerald-400'
                                            : 'tw-text-emerald-600 tw-border-b-2 tw-border-emerald-600'
                                        : theme === 'dark'
                                            ? 'tw-text-slate-400 hover:tw-text-slate-300'
                                            : 'tw-text-slate-500 hover:tw-text-slate-600'
                                ]"
                            >
                                Principal
                            </button>
                            <button
                                @click="activateTabPrincipal(false)"
                                :class="[
                                    'tw-pb-4 tw-font-semibold tw-text-sm',
                                    !tabPrincipal
                                        ? theme === 'dark' 
                                            ? 'tw-text-emerald-400 tw-border-b-2 tw-border-emerald-400'
                                            : 'tw-text-emerald-600 tw-border-b-2 tw-border-emerald-600'
                                        : theme === 'dark'
                                            ? 'tw-text-slate-400 hover:tw-text-slate-300'
                                            : 'tw-text-slate-500 hover:tw-text-slate-600'
                                ]"
                            >
                                Parâmetros
                            </button>
                        </div>
                    </div>

                    <div class="tw-mt-6">
                        <div v-if="tabPrincipal">
                            <TermometriaComponent :theme="theme" :silo="silo" :leituras="leituras" :termometria="termometria" @selectedLeitura="fetchTermometria"/>
                        </div>

                        <div v-if="!tabPrincipal">
                            <ParametrosComponent :theme="theme" :silo="silo" @salvar-parametros="salvarParametrosApi" @cancelar-parametros="cancelarAlteracoes" :saveParametrosLoading="parametrosStoreLoading"/>
                        </div>
                    </div>
                </section>
            </div>
        </main>
    </MainLayout>
</template>

<script>
import MainLayout from '@/components/layouts/v2/MainLayout.vue';
import EstacaoComponent from '@/components/ui/v2/EstacaoComponent.vue';
import HeaderSilo from '@/components/ui/v2/HeaderSilo.vue';
import LoaderPage from '@/components/ui/v2/LoaderPage.vue';
import TermometriaComponent from '@/components/ui/v2/Silo/TermometriaComponent.vue';
import ParametrosComponent from '@/components/ui/v2/Silo/ParametrosComponent.vue';

import { ref, onMounted, watch, computed } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { useToast } from "vue-toastification";


export default {
    components: {
        MainLayout,
        EstacaoComponent,
        HeaderSilo,
        LoaderPage,
        TermometriaComponent,
        ParametrosComponent
    },
    setup () {

        const store = useStore();
        const route = useRoute();
        const toast = useToast();
        const leituras = ref([]);
        const siloId = ref('');
        const termometria = ref({});
        const unidade = ref();
        const silo = ref({
            "cabos": {},
            "aeracao": {},
            "programa": {
                "descricao": ""
            },
            "produto": {
                "descricao": ""
            },
            "parametros": {}
        });
        const loadingPage = ref(true);

        const theme = computed(() => store.state.ui.theme);

        const isTermocloud = computed(() =>
            String(store.state.unidade.unidade?.tipo_produto || '').toLowerCase() === 'termocloud'
        );

        const tabPrincipal = ref(true);
        const fetchSiloById = async (siloId) => {
            try {
                const response = await store.dispatch('silo/fetchSiloById', siloId);
                silo.value = response;
                leituras.value = silo.value.leituras;
                const primeiraProcessada = leituras.value.find(l => l && l.data_processamento != null);
                if (primeiraProcessada) {
                    fetchTermometria(primeiraProcessada._id);
                }
            } catch (error) {
                console.error('Error to request Silo, message:', error);
                toast.error('Erro ao obter dados do silo');
            }
        }

        const fetchTermometria = async (leituraId) => {
            try {
                const body = {
                    "siloId": siloId.value,
                    "leituraId": leituraId
                }
                const data = await store.dispatch("leituras/fetchLeituraById", body);
                termometria.value = data
            } catch (error) {
                console.error("Erro ao buscar dados de termometria:", error);
                toast.error('Erro ao buscar dados de termometria');

            }
        };

        const requestDatasBySilo = async () => {
            loadingPage.value = true;
            silo.value = {};
            termometria.value = {};
            siloId.value = route.params.silo;
            await fetchSiloById(siloId.value);
            loadingPage.value = false;
        };

        onMounted(requestDatasBySilo);

        watch(() => route.params.silo, () => {
            requestDatasBySilo();
        });

        watch(silo, (newSilo) => {
            if (newSilo?.nome) {
                document.title = `${newSilo.nome} - Winckieel Cloud`;
            }
        }, { deep: true });

        return {
            silo,
            unidade,
            leituras,
            fetchTermometria,
            termometria,
            loadingPage,
            unidadeId: route.params.unidade,
            tabPrincipal,
            activateTabPrincipal: (action) => tabPrincipal.value = action,
            requestDatasBySilo,
            toast,
            theme,
            isTermocloud
        };
    },
    methods: {
        async salvarParametrosApi(datas) {
            try{
                this.parametrosStoreLoading = true
                let a = await this.$store.dispatch('silo/saveParametrosAeracao', {"data": datas.parametros, "siloId": this.silo.id})
                let b = await this.$store.dispatch('silo/saveAeracao', {"data": datas.aeracao, "siloId": this.silo.id})
                const isTermocloud = this.isTermocloud;
                const destino = isTermocloud ? 'TermoCloud' : 'Painel TermoWeb';
                const messageIds = isTermocloud
                    ? [b.message.original.message.message_id]
                    : [a.message.original.message.message_id, b.message.original.message.message_id];
                this.toast.info(`Parâmetros enviados ao ${destino}, aguardando confirmação...`, { timeout: 3900 });
                setTimeout(async () => {
                    const msgs = await Promise.all(messageIds.map(id => this.$store.dispatch("message/fetchMessage", id)));
                    if (msgs.some(msg => msg.status !== 'processed')) {
                        this.toast.error(`Parâmetros não processados pelo ${destino}.`);
                    } else {
                        this.toast.success("Parâmetros atualizados com sucesso.");
                    }
                }, 4000);
                this.requestDatasBySilo()
                this.parametrosStoreLoading = false
            } catch (error){
                this.requestDatasBySilo()
                this.toast.error("Erro ao atualizar parâmetros: \n" + error.response.data.message)
                this.parametrosStoreLoading = false
            }
        },
        cancelarAlteracoes() {
            this.requestDatasBySilo();
        }
    },
    data() {
        return {
            parametrosStoreLoading: false
        }
    },
}
</script>